import {useContext, useEffect, useState} from "react";
// @ts-ignore
import {CourseModal} from "./CourseModal.tsx";
// @ts-ignore
import {APIContext} from "./Globals.tsx";
// @ts-ignore
import arrowdown from "../img/arrwodown.png";
// @ts-ignore
import arrowup from "../img/arrowup.png";
import {weekdays} from "./ToDos";

export default function DashCalendar({users}){
  const [week, setWeek] = useState([]);
  const [courseModal, setCourseModal] = useState(null);
  const [locations, setLocations] = useState([]);
  const [date, setDate] = useState(new Date());
  const [isThisWeek, setIsThisWeek] = useState(true);
  const {getWeek, fetchLocations} = useContext(APIContext);

  useEffect(() => {
    fetchLocations().then((l) => setLocations(l.locations))
  }, []);

  useEffect(() => {
    getWeek(date).then((ans) => {
      let week_ = ans?.days ?? [];
      week_.length > 0 && week_.find((day, i) => {
        return day.length > 0 && i > 0;

      })
      setIsThisWeek(date.toDateString() === new Date().toDateString())
      setWeek(week_);
    });
  }, [date]);

  return <div style={{position: "relative"}}>
    <div style={{position: "absolute", right: 0}}>
      <img src={arrowup} className="dreieck" onClick={() => {
        const nextWeekDate = new Date(date);
        nextWeekDate.setDate(date.getDate() - 7);
        setDate(nextWeekDate);
      }} alt={"arrow up"} style={{width:20, height:20, marginRight: 20}}/>
      <img src={arrowdown} className="dreieck" onClick={() => {
        const nextWeekDate = new Date(date);
        nextWeekDate.setDate(date.getDate() + 7);
        setDate(nextWeekDate);
      }} alt={"arrow down"} style={{width:20, height:20}}/>
    </div>
    <div>
      {courseModal && <CourseModal onClose={() => setCourseModal(null)} course={courseModal} locations={locations}
                                   users={users.length > 2 && users[2].persons} setCourse={setCourseModal}/>}
      {week.map((day, i) => {
        if(!(day.length > 0)){
          return null
        }
        return <div>
          <h3>{isThisWeek ? i === 0 ? "Heute" : i === 1 ? "Morgen" : weekdays[(date.getDay() + 6 + i) % 7].name : weekdays[(date.getDay() + 6 + i) % 7].name + " - " + new Date(date.getTime() + i * 24 * 3600 * 1000).toLocaleDateString('de-DE')}</h3>
          {day.map(item => <div className={"courseCard centerVertical"} onClick={() => {
            setCourseModal(item);
          }}>
            <h4>{item.startTime} - {item.endTime} Uhr</h4>
            <h4 style={{color: "var(--accent)"}}>{item.type}</h4>
            <div>{item.participants.length}/{item.participantsMax}</div>
          </div>)}
        </div>
      })}
    </div>
  </div>;
}